module.exports = __webpack_public_path__ + "static/media/magicbanner.8dfbd0c1.png";